import React, { useEffect, useState,  } from 'react'
import { Modal, Steps, Form, Space, App, Radio } from 'antd'        
import Icon from '../../../cpn/Icon';
import UserSelect from '../../user/UserSelect';
import { useJKspjdPLAddMutation } from '../../../store/DianShangYeWuApi';
function LoanNodeAdd(props) {    
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState({
        node_type: '',
        node_user_name: '',
        node_content: '',
        node_user_id: '',
    });
    // eslint-disable-next-line no-unused-vars
    const [user, setUser] = useState({jk_spjd_user_id:'',jk_spjd_user_name:''});
    const [newNode, setNewNode] = useState([]);    
    // 初始 items 状态，使用 useMemo 避免每次渲染都重新创建    
    const [items, setItems] = useState([]);
   
    useEffect(() => {
        setItems([
            ...newNode,
        ]);
    }, [newNode]);
    const [submitAdd] = useJKspjdPLAddMutation()    
    const onAdd = () => {
        let obj ={
            'jk_spjd_qy_id': props.qy_id,
            'jk_spjd_qy_name': props.qy_name,
            'jk_spjd_xuhao': '',
            'jk_spjd_name': '',
            'jk_spjd_yh_id': '',
            'jk_spjd_yh_name': '',
            'jk_spjd_uid': props.yh_id,
            'jk_spjd_uname': props.yh_name,
            'jk_spjd_content': '',
            'jk_spjd_user_id': user.jk_spjd_user_id,
            'jk_spjd_user_name': user.jk_spjd_user_name,
        }
        // 1. 校验填单人
        if (!user.jk_spjd_user_id || !user.jk_spjd_user_name) {
            message.error("请先选择借款单操作员");
            return;
        }
        // 2. 校验 items 节点
        if (!items || items.length === 0 || (items.length === 1 && !items[0].jk_spjd_yh_id)) {
            message.error("请设置至少一个审批/抄送节点");
            return;
        }
        // 3. 过滤掉无效节点
        const validItems = items.filter(item => !!item.jk_spjd_yh_id && !!item.jk_spjd_yh_name);

        // 4. 填充 obj 字段
        // 不需要前面1,2两个元素了，直接从items的第一个开始
        // 填充序号
        let s = validItems.length;
        let xuhaoArr = [];
        for(let i=1; i<=s; ++i) xuhaoArr.push(i);
        obj.jk_spjd_xuhao = xuhaoArr.join(',');

        // 填充jk_spjd_name
        obj.jk_spjd_name = validItems.map(item => item.jk_spjd_name).join(',');

        // 填充jk_spjd_yh_id
        obj.jk_spjd_yh_id = validItems.map(item => item.jk_spjd_yh_id).join(',');

        // 填充jk_spjd_yh_name
        obj.jk_spjd_yh_name = validItems.map(item => item.jk_spjd_yh_name).join(',');

        // 填充jk_spjd_content
        obj.jk_spjd_content = validItems.map(item => item.content || '').join(',');

        // 5. 提交
        submitAdd(obj).then(res => {
            if (res && res.data && res.data.Status === 'success') {
                message.success('新增成功');
                setOpen(false);
                setNewNode([]);
                setItems([]);
                setUser({jk_spjd_user_id:'',jk_spjd_user_name:''});
                props.onSuccess && props.onSuccess();
            } else {
                message.error('新增失败：' + (res?.data?.Message || '未知错误'));
            }
        });
    }
    return (
        <>
            <Icon 
                type='add' 
                onClick={() => {
                    setOpen(true);
                    form.setFieldsValue({ jk_spjd_user_id: undefined });
                }}  
                title='新增'
            />
            <Modal
                open={open}
                onCancel={() => {
                    setOpen(false);
                    // 清空所有状态
                    setNewNode([]);
                    setItems([]);
                    setUser({jk_spjd_user_id:'',jk_spjd_user_name:''});
                }}
                onOk={() => {}}
                title='新增'
                footer={null}
                width={800}
            >
                <Form form={form} layout='horizontal' labelCol={{ span: 6 }}>
                    <UserSelect
                        qy_id={props.qy_id}
                        onChange={(value) => {
                            setUser({jk_spjd_user_id:value.yh_id,jk_spjd_user_name:value.yh_name});
                        }}
                        label="借款单操作员"
                        name="jk_spjd_user_id"
                        required
                        wrapperCol={{ span: 8 }}
                        placeholder="请选择借款单操作员"
                    />           
                    <Form.Item label="审批类型及操作员" required wrapperCol={{ span: 18 }}>
                        <Space size={10}>
                            <Form.Item  name="node_type" noStyle>
                                <Radio.Group
                                    onChange={(e) => {
                                        setInfo(prev=>({...prev, node_type: e.target.value}))
                                    }}
                                >
                                    <Radio value="审批">审批</Radio>
                                    <Radio value="抄送">抄送</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <UserSelect 
                                qy_id={props.qy_id}
                                onChange={(value) => {
                                    console.log(value);
                                    setInfo(prev=>({...prev, node_user_name: value.yh_name, node_user_id: value.yh_id}))
                                }}
                                name="node_user_id"
                                required
                                placeholder={info.node_type === '审批' ? '请选择审批人' : '请选择抄送人'}
                                disabled={info.node_type === ''}
                                formStyle={{ marginBottom: 0 }}
                                style={{ width: '200px' }}
                            />  
                            <Icon 
                                type='add' 
                                onClick={() => {
                                if(!info.node_type){
                                    message.error('请选择节点类型')
                                    return;
                                }
                                if(!info.node_user_name){
                                    message.error('请选择操作员')
                                    return;
                                }
                                setNewNode(prev => [...prev, {
                                    title: info.node_type + '：' + info.node_user_name,
                                    content: '',
                                    status: 'wait',
                                    jk_spjd_name: info.node_type,
                                    jk_spjd_yh_id: info.node_user_id,
                                    jk_spjd_yh_name: info.node_user_name,
                                }]);
                                form.resetFields(['node_type', 'node_user_id', 'node_content']);
                                setInfo(prev => ({
                                    ...prev,
                                    node_type: '',
                                    node_user_name: '',
                                    node_content: '',
                                    node_user_id: '',
                                }));
                                }} title='添加审批节点' 
                            />
                        </Space>
                    </Form.Item>
                    <Form.Item label="审批点">
                        {items.length===0 && ''}
                        <div>
                                <style>
                                    {`
                                        .ant-steps-item-title {
                                            color: #000 !important;
                                        }
                                    `}
                                </style>
                                <Steps
                                    items={items}
                                    orientation="vertical"  
                                    size="small"
                                    current={items.length-1}
                                />
                            </div>
                    </Form.Item>  
                    <Form.Item wrapperCol={{ offset: 6,}}>
                        <Space size={30}>
                            <Icon 
                                type='save' 
                                onClick={onAdd} 
                                title='保存' 
                                key='save'
                            />
                            <Icon 
                                type='reset' 
                                onClick={() => {
                                    form.resetFields();
                                    setItems([]);
                                    setUser({jk_spjd_user_id:'',jk_spjd_user_name:''});
                                    setNewNode([]);
                                }} 
                                title='重置' 
                                key='reset'
                                style={{marginLeft:'10px'}}
                            />
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}
export default LoanNodeAdd